"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfficesStatsApiSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const officeStatsItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('offices'),
    attributes: zod_1.z.object({
        siteId: zod_1.z.string(),
        name: zod_1.z.string(),
        occupancy: zod_1.z.number().optional().default(0),
        bookedSlots: zod_1.z.number().optional().default(0),
        openSlots: zod_1.z.number().optional().default(0),
        slotsToValidate: zod_1.z.number().optional().default(0),
        filledSlots: zod_1.z.number().optional().default(0),
        availableSlots3Months: zod_1.z.number().optional().default(0),
        slotsToValidate2Months: zod_1.z.number().optional().default(0),
        /** Set when the practice closed; closed practices stay in the statistics. */
        deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
    }),
});
exports.getOfficesStatsApiSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(officeStatsItemApiResponseSchema);
